// aifab - Navigation structure
// Grouped for data scientist workflow:
//   WORKSPACE  → orientation + project setup
//   EXPERIMENT → the core DS workflow: data → model → run
//   PLATFORM   → infrastructure

export const NAV = [
  // ── Workspace ──────────────────────────────────────────────────
  { key: 'dashboard', label: 'Dashboard',  icon: '◈', section: 'Workspace' },
  { key: 'projects',  label: 'Projects',   icon: '⬡', section: 'Workspace' },

  // ── Experiment ─────────────────────────────────────────────────
  { key: 'data',      label: 'Data',       icon: '⊞', section: 'Experiment' },
  { key: 'models',    label: 'Models',     icon: '◉', section: 'Experiment' },
  { key: 'runs',      label: 'Runs',       icon: '▶', section: 'Experiment' },
  { key: 'lineage',   label: 'Lineage',    icon: '⎇', section: 'Experiment' },

  // ── Platform ───────────────────────────────────────────────────
  { key: 'servers',   label: 'Servers',      icon: '▲', section: 'Platform', minRole: null },
  { key: 'plugins',   label: 'Plugins',      icon: '⬢', section: 'Platform', minRole: null },
  { key: 'catalog',   label: 'Model Catalog',icon: '⊡', section: 'Platform', minRole: null },
  { key: 'admin',     label: 'Admin',        icon: '⚙', section: 'Platform', minRole: 'ORG_ADMIN' },
];
